import { DataSubmissionsFilterArea } from "#src/batteries-included-components/FilterAreas/DataSubmissionFilterAreas";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";
import { DataSetSubmissionsTablePanel } from "./DataSetSubmissionsTablePanel";

export const DataSetSubmissionsListTab = () => {
  const [viewConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["view-configuration", "table-configuration", "table-state"],
      "dataset-submissions"
    );

  return (
    <>
      <DataSubmissionsFilterArea viewConfigStorageKey={viewConfigStorageKey} />
      <DataSetSubmissionsTablePanel
        viewConfigStorageKey={viewConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
